export enum ShopperAgentGenerationMode {
  Template = "template",
  Ai = "ai",
}
